const u = (a) => ({
  install: (t) => {
    t.config.globalProperties.$translate = (r, e) => a.translate(r, e), t.config.globalProperties.$dateTimeFormat = (r) => a.dateTimeFormat(r);
  }
});
class l {
  replace(t, r) {
    return t.replace(/{\w+}/g, function(e) {
      return r[e.substring(1, e.length - 1)] || e;
    });
  }
}
class i {
  constructor(t) {
    this.lang = t;
  }
  dateTimeFormat(t) {
    return new Date(t).toLocaleDateString(this.lang, {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  }
}
const c = (a, t) => a.reduce((r, e) => r[e], t);
class d {
  constructor(t = "de", r, e = [new l()], n = new i(
    t
  )) {
    this.lang = t, this.translations = r, this.replacers = e, this.dateTranslator = n;
  }
  translate(t, r) {
    const e = t.split(".");
    try {
      const n = c(e, this.translations);
      return n || console.error(`Translation for key ${t} not found`), r ? this.replacers.reduce(
        (o, s) => s.replace(o, r),
        n
      ) : n;
    } catch {
      console.error(`Translation for key ${t} not found`);
    }
  }
  dateTimeFormat(t) {
    return this.dateTranslator.dateTimeFormat(t);
  }
}
export {
  d as Translator,
  u as createPlugin
};
